import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typo, Input, Modal } from '@ers/ui';
import { useDispatch } from 'react-redux';
import { sendAddApplicationContinueBtnEvent } from '@ers/root/App.actions';
import { useInput } from '@ers/hooks/';
import { useWizard } from '../../context/WizardContextContainer';


const Step1 = ({ onClick }) => {
    const dispatch = useDispatch();
    const { goToNextStep } = useWizard();
    const position = useInput();
    const company = useInput();

    const handleClick = () => {
        const positionName = position.value;
        const companyName = company.value;
        dispatch(sendAddApplicationContinueBtnEvent({ positionName, companyName }));
        goToNextStep();
    };

    return (
        <>
            <Typo.Body className="with-margin--bottom-5">
                Tylko część aplikacji, które wysyłasz, zapisuje się automatycznie w Twoim Koncie Kandydata.
                Dodaj samodzielnie pozostałe, żeby mieć wszystkie wysłane aplikacje w jednym miejscu i śledzić swoje postępy w poszukiwaniu pracy.
            </Typo.Body>
            <div>
                <Input {...position} className="with-margin--bottom-2" label="Nazwa stanowiska" />
                <Input {...company} className="with-margin--bottom-5" label="Firma" />
            </div>
            <Modal.Footer>
                <Button.Tertiary onClick={onClick}>
                    Anuluj
                </Button.Tertiary>
                <Button.Primary onClick={handleClick}>
                    Dodaj
                </Button.Primary>
            </Modal.Footer>
        </>
    );
};

Step1.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default Step1;
